(function () {
  window.addEventListener('DOMContentLoaded', function () {
    const addToCartBtn = document.querySelector('.add-to-cart');

    if (addToCartBtn) {
      setTimeout(() => {
        addToCartBtn.style.display = '';
      }, 3500);
    }
  });
})();

// IE Product Options
(function () {
  window.addEventListener('load', function () {
    const productForm = document.querySelector('form[action^="/cart/add"]');
    if (!productForm) return;

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(productForm);
      const items = [];

      const mainVariantId = formData.get('id');
      const mainQuantity = formData.get('quantity') || 1;

      // PSN validation — only if visible
      const psnInput = document.getElementById('powerlink-serial');
      const psnError = document.getElementById('psn-error');
      const psnField = document.querySelector('.ie-psn-field');
      const psnRegex = /^[vV][34] [0-9]{5}$/;

      let psnValue = '';
      let properties = {};
      const psnFieldIsVisible = psnField && psnField.offsetParent !== null;

      if (psnInput && psnFieldIsVisible) {
        psnValue = psnInput.value.trim();

        if (!psnRegex.test(psnValue)) {
          psnError.style.display = 'block';
          return;
        } else {
          psnError.style.display = 'none';
          properties['PSN'] = psnValue;
        }
      }

      // Main product with optional PSN property
      const mainProduct = {
        id: mainVariantId,
        quantity: parseInt(mainQuantity)
      };

      if (Object.keys(properties).length > 0) {
        mainProduct.properties = properties;
      }

      items.push(mainProduct);

      // ✅ Add-on checkbox 1 (POWERlink)
      const addonCheckboxEl = document.getElementById('addon-checkbox');
      if (addonCheckboxEl && addonCheckboxEl.checked) {
        const variantId = addonCheckboxEl.getAttribute('data-variant-id');
        if (variantId) {
          items.push({ id: variantId, quantity: 1 });
        }
      }

      // ✅ Add-on checkbox 2
      const addonCheckbox2El = document.getElementById('addon-checkbox-2');
      if (addonCheckbox2El && addonCheckbox2El.checked) {
        const variantId2 = addonCheckbox2El.getAttribute('data-variant-id');
        if (variantId2) {
          items.push({ id: variantId2, quantity: 1 });
        }
      }

      // ✅ Dropdown add-ons
      const addonSelect = document.getElementById('addon-select');
      if (addonSelect && addonSelect.value !== '') {
        items.push({ id: addonSelect.value, quantity: 1 });
      }

      const addonSelect2 = document.getElementById('addon-select-2');
      if (addonSelect2 && addonSelect2.value !== '') {
        items.push({ id: addonSelect2.value, quantity: 1 });
      }

      console.log('Prepared items:', items);

      // ✅ Add items one-by-one using sequential fetches
      const addToCart = (item) => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(item)
        });
      };

      // Sequentially add all items
      (async () => {
        try {
          for (const item of items) {
            await addToCart(item);
          }

          console.log('All items added to cart.');

          // ✅ Trigger Impulse cart drawer to update and open
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true
          }));

        } catch (error) {
          console.error('Error adding to cart:', error);
        }
      })();
    });
  });
})();

// PSN counter + toggle visibility
(function () {
  window.addEventListener('load', function () {
    const psnInput = document.getElementById('powerlink-serial');
    const psnCounter = document.getElementById('psn-counter');
    const psnField = document.querySelector('.ie-psn-field');
    const powerlinkAddonCheckbox = document.querySelector('.powerlink-addon input');
    const psnRegex = /^[vV][34] [0-9]{5}$/;

    // 🚫 Exit early for non-PSN products or explicitly hidden
    if (
      (!psnInput && !powerlinkAddonCheckbox) ||
      (psnField && psnField.classList.contains('hide-psn-field'))
    ) {
      return;
    }

    function getAddToCartButton() {
      return document.querySelector('.add-to-cart');
    }

    function validate() {
      const addToCartButton = getAddToCartButton();
      if (!addToCartButton) return;

      const psnValue = psnInput?.value.trim() || '';
      const isPsnVisible = psnField && psnField.offsetParent !== null;
      const isPsnValid = psnRegex.test(psnValue);
      const powerlinkChecked = powerlinkAddonCheckbox?.checked;

      const shouldEnable =
        (isPsnVisible && isPsnValid) ||
        (!isPsnVisible && powerlinkChecked);

      addToCartButton.disabled = !shouldEnable;
    }

    // Character counter
    if (psnInput && psnCounter) {
      psnInput.addEventListener('input', function () {
        const len = psnInput.value.length;
        psnCounter.style.display = len > 0 ? 'inline' : 'none';
        psnCounter.textContent = `${len} | 8`;
        validate();
      });
    }

    // POWERlink checkbox toggle
    if (powerlinkAddonCheckbox && psnField) {
      const togglePsnField = () => {
        psnField.style.display = powerlinkAddonCheckbox.checked ? 'none' : '';
        validate();
      };

      powerlinkAddonCheckbox.addEventListener('change', togglePsnField);
      togglePsnField(); // Initial state
    }

    // ✅ Re-run validation after variant changes
    document.addEventListener('change', function (e) {
      if (
        e.target.matches('select[name="id"]') ||
        e.target.closest('variant-radios') ||
        e.target.closest('variant-selects')
      ) {
        // Delay slightly to allow DOM replacement to finish
        setTimeout(validate, 50);
      }
    });

    validate(); // Initial check
  });
})();

// IE Vehicle Selectors
(function() {
  // JSON structure from the CSV file
  const vehicleData = {
    "Audi": {
      "A3": {
        "8Y (2022-2024)": "/collections/all/8Y-A3",
        "8V (2015-2021)": "/collections/all/8V-A3",
        "8P (2006 - 2013)": "/collections/all/8P-A3",
        "8L (1996 - 2003)": "/collections/all/8L-A3"
      },
      "A4": {
        "B9 (2017-2024)": "/collections/all/B9-A4",
        "B8 / B8.5 (2009 - 2016)": "/collections/all/B8-A4",
        "B7 (2005 - 2008)": "/collections/all/B7-A4",
        "B6 (2002 - 2005)": "/collections/all/B6-A4",
        "B5 (1996 - 2001)": "/collections/all/B5-A4"
      },
      "A4 Allroad": {
        "B9 (2017-2024)": "/collections/all/B9-A4",
        "B8 / B8.5 (2009 - 2016)": "/collections/all/B8-A4"
      },
      "A5": {
        "B9 (2016-2024)": "/collections/all/B9-A5",
        "B8 (2008 - 2015)": "/collections/all/B8-A5"
      },
      "A6": {
        "C8 (2019-2024)": "/collections/all/C8-A6",
        "C7 (2010 - 2018)": "/collections/all/C7-A6",
        "C6 (2005 - 2011)": "/collections/all/C6-A6",
        "C5 (1998 - 2004)": "/collections/all/C5-A6"
      },
      "A7": {
        "C8 (2019-2024)": "/collections/all/C8-A7",
        "C7 (2010 - 2018)": "/collections/all/C7-A7"
      },
      "A8": {
        "D4 (2009 - 2015)": "/collections/all/D4-A8"
      },
      "E-Tron": {
        "MLB (2018-2024)": "/collections/all/MLB-Etron"
      },
      "Q3": {
        "F3 (2019-2024)": "/collections/all/F3-Q3",
        "8U (2011 - 2015)": "/collections/all/8U-Q3"
      },
      "Q5": {
        "8R (2008 - 2016)": "/collections/all/8R-Q5",
        "B9/80A (2018-2024)": "/collections/all/B9-Q5"
      },
      "Q7": {
        "4L (2007 - 2015)": "/collections/all/4L-Q7"
      },
      "R8": {
        "42 (2008 - 2015)": "/collections/all/42-R8",
      },
      "RS3": {
        "8Y (2022-2024)": "/collections/all/8Y-RS3",
        "8V (2017-2020)": "/collections/all/8V-RS3"
      },
      "RS4": {
        "B9 (2018-2024)": "/collections/all/B9-RS4",
        "B7 (2005 - 2008)": "/collections/all/B7-RS4",
        "B5 (1996 - 2001)": "/collections/all/B5-RS4"
      },
      "RS5": {
        "B9 (2018-2024)": "/collections/all/B9-RS5",
        "B8 (2008 - 2015)": "/collections/all/B8-RS5"
      },
      "RS6": {
        "C8 (2021-2024)": "/collections/all/C8-RS6",
      },
      "RS7": {
        "C7 (2014-2018)": "/collections/all/C7-RS7",
        "C8 (2021-2024)": "/collections/all/C8-RS7"
      },
      "RSQ8": {
        "4M (2020-2024)": "/collections/all/4M-RSQ8"
      },
      "S3": {
        "8Y (2022-2024)": "/pages/ie-2-0-mk8",
        "8V (2015-2021)": "/collections/all/8V-S3"
      },
      "S4": {
        "B9 (2017-2024)": "/pages/ie-2-0-b9",
        "B8 / B8.5 (2009 - 2016)": "/collections/all/B8-S4",
        "B6 (2002 - 2005)": "/collections/all/B6-S4",
        "B5 (1996 - 2001)": "/collections/all/B5-S4"
      },
      "S5": {
        "B9 (2017-2024)": "/pages/ie-2-0-b9",
        "B8 (2008 - 2015)": "/collections/all/B8-S5"
      },
      "S6": {

        "": "/collections/all/C8-S6",
        "C7 / C7.5 (2012-2018)": "/collections/all/C7-S6"
      },
      "S7": {
        "": "/collections/all/C8-S7",
        "C7 / C7.5 (2012-2018)": "/collections/all/C7-S7"
      },
      "S8" : {

        "2020-2023 (D5)": "/collections/all/D5-S8",
      },
      "SQ5": {

        "B9 (2018-2024)": "/collections/all/B9-SQ5",
        "8R (2008 - 2016)": "/collections/all/8R-SQ5"
      },
      "SQ7": {

        "4M (2020-2024)": "/collections/all/4M-SQ7",
      },
      "SQ8": {

        "4M (2020-2024)": "/collections/all/4M-SQ8",
      },
      "TT": {
        "8S (2015-2023)": "/collections/all/8S-TT",
        "8N (1998 - 2006)": "/collections/all/8N-TT"
      },
      "TT-RS": {
        "8S (2017-2020)": "/collections/all/8S-TT-RS",
        "8J (2008 - 2015)": "/collections/all/8J-TT-RS"
      },
      "TT-S": {
        "8S (2015-2023)": "/collections/all/8S-TT-S",
        "8J (2008 - 2015)": "/collections/all/8J-TT-S",
      }
    },
    "Porsche": {
      "Cayenne": {
        "9Y (2019-2024)": "/collections/all/9Y-Cayenne"
      }
    },
    "VW": {
      "Golf / SportWagen / Alltrack": {
        "MK7 (2015-2021)": "/collections/all/MK7-Golf",
        "MK6 (2010-2014)": "/collections/all/MK6-Golf",
        "MK4 (1999-2005)": "/collections/all/MK4-Golf",
        "MK3 (1993-1999)": "/collections/all/MK3-Golf"
      },
      "Golf R": {
        "MK8 (2022-2024)": "/pages/ie-2-0-mk8",
        "MK7 (2015-2021)": "/collections/all/MK7-R",
        "MK6 (2012 - 2013)": "/collections/all/MK6-R"
      },
      "GTI": {
        "MK8 (2022-2024)": "/pages/ie-2-0-mk8",
        "MK7 (2015-2021)": "/collections/all/MK7-GTI",
        "MK6 (2010 - 2014)": "/collections/all/MK6-GTI",
        "MK5 (2006 - 2009)": "/collections/all/MK5-GTI",
        "MK4 (1999 - 2005)": "/collections/all/MK4-GTI",
        "MK3 (1993 - 1999)": "/collections/all/MK3-GTI"
      },
      "GLI": {
        "MK7 (2019-2024)": "/collections/all/MK7-GLI$$$tag$$$1",
        "MK6 (2010 - 2018)": "/collections/all/MK6-GLI",
        "MK5 (2006 - 2010)": "/collections/all/MK5-Jetta",
        "MK4 (1999 - 2005)": "/collections/all/MK4-GLI",
        "MK3 (1993 - 1999)": "/collections/all/MK3-GLI"
      },
      "Atlas": {
        "MQB (2018-2023)": "/collections/all/MQB-Atlas"
      },
      "Tiguan": {
        "Gen 3 (2018-2023)": "/collections/all/MQB-Tiguan",
        "5N (2009 - 2017)": "/collections/all/5N-Tiguan"
      },
      "Jetta": {
        "MK7 (2019-2024)": "/collections/all/MK7-Jetta",
        "MK6 (2010 - 2018)": "/collections/all/MK6-Jetta",
        "MK5 (2006 - 2010)": "/collections/all/MK5-Jetta",
        "MK4 (1999 - 2005)": "/collections/all/MK4-Jetta",
        "MK3 (1993 - 1999)": "/collections/all/MK3-Jetta"
      },
      "Jetta SportWagen": {
        "MK6 (2011 - 2014)": "/collections/all/MK6-JSW"
      },
      "R32": {
        "MK5 (2006-2009)": "/collections/all/MK5-R32",
        "MK4 (2004)": "/collections/all/MK4-R32"
      },
      "Rabbit": {
        "MK5 (2006 - 2009)": "/collections/all/MK5-Rabbit"
      },
      "Beetle": {
        "MK2 (2011 - 2015)": "/collections/all/Beetle2",
        "1C (1998 - 2011)": "/collections/all/Beetle1"
      },
      "EOS": {
        "1F7 (2006 - 2015)": "/collections/all/1F7-EOS"
      },
      "Passat": {
        "B7 (2010 - 2015)": "/collections/all/B7-Passat",
        "B6 (2006 - 2010)": "/collections/all/B6-Passat",
        "B5 (1998 - 2005)": "/collections/all/B5-Passat"
      },
      "CC": {
        "3C (2009 - 2015)": "/collections/all/3C-CC"
      },
      "Corrado": {
        "A3 (1988 - 1995)": "/collections/all/A3-Corrado"
      }
    }
  };

  // Dropdown handling for both selectors
  document.querySelectorAll('.ie-hero-vehicle-selector, .ie-sticky-vehicle-selector').forEach(selectorContainer => {
    const dropdowns = selectorContainer.querySelectorAll('.selector-dropdown');

    function populateDropdown(dropdown, options) {
      const selectionOptions = dropdown.querySelector('.selection-options');
      selectionOptions.innerHTML = '';
      options.forEach(option => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'selection-option';
        optionDiv.setAttribute('data-value', option);
        optionDiv.innerHTML = `<span class="selection-active-indicator"></span><p>${option}</p>`;
        selectionOptions.appendChild(optionDiv);
      });
      reattachOptionClickListeners(dropdown);
    }

    function resetDropdown(dropdown, placeholder) {
      const label = dropdown.querySelector('.selection-label > p');
      label.textContent = placeholder;
      dropdown.querySelector('.selection-options').innerHTML = '';
    }

    function reattachOptionClickListeners(dropdown) {
      const nextDropdown = dropdown.nextElementSibling;
      dropdown.querySelectorAll('.selection-option').forEach(option => {
        option.addEventListener('click', function() {
          handleOptionClick(dropdown, option, nextDropdown);
        });
      });
    }

    function handleDropdownClick(dropdown) {
      if (dropdown.classList.contains('selectable')) {
        if (dropdown.classList.contains('active')) {
          dropdown.classList.remove('active');
        } else {
          dropdowns.forEach(d => d.classList.remove('active'));
          dropdown.classList.add('active');
        }
      }
    }

    function handleOptionClick(dropdown, option, nextDropdown) {
      const selectedValue = option.getAttribute('data-value');
      dropdown.querySelectorAll('.selection-option').forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');
      const label = dropdown.querySelector('.selection-label > p');
      label.textContent = selectedValue;

      dropdown.classList.remove('active');
      dropdown.classList.add('selectable');

      const selectedMake = selectorContainer.querySelector('.select-make .selection-label > p').textContent;
      const selectedSeries = selectorContainer.querySelector('.select-series .selection-label > p').textContent;
      const selectedModel = selectorContainer.querySelector('.select-model .selection-label > p').textContent;

      if (selectedMake && selectedSeries && selectedModel) {
        const selectionKey = "easysearch-preselect";
        const selectionValue = {
          value: `${selectedMake}easysearch-preselect-delimiter${selectedSeries}easysearch-preselect-delimiter${selectedModel}easysearch-preselect-delimiter`,
          expires: Date.now() + (24 * 60 * 60 * 1000) // Expires in 24 hours
        };
        localStorage.setItem(selectionKey, JSON.stringify(selectionValue));

        const url = vehicleData[selectedMake]?.[selectedSeries]?.[selectedModel];
        if (url) {
          const tagFilterKey = "easysearch-tag-filter";
          const tagFilterValue = {
            value: url.split('/').pop().toLowerCase(),
            expires: Date.now() + (24 * 60 * 60 * 1000) // Expires in 24 hours
          };
          localStorage.setItem(tagFilterKey, JSON.stringify(tagFilterValue));
          
          window.location.href = url;
        }
      }

      if (nextDropdown) {
        nextDropdown.classList.add('selectable');
        if (dropdown.classList.contains('select-make')) {
          populateDropdown(nextDropdown, Object.keys(vehicleData[selectedValue]));
          resetDropdown(selectorContainer.querySelector('.select-model'), 'Select Model');
        } else if (dropdown.classList.contains('select-series')) {
          populateDropdown(nextDropdown, Object.keys(vehicleData[selectedMake][selectedSeries]));
        }
      }
    }

    dropdowns.forEach((dropdown, index) => {
      const nextDropdown = dropdowns[index + 1];
      dropdown.querySelector('.selection-label').addEventListener('click', function() {
        handleDropdownClick(dropdown);
      });
      reattachOptionClickListeners(dropdown);
    });

    document.addEventListener('click', function(event) {
      if (!event.target.closest('.ie-hero-vehicle-selector') && !event.target.closest('.ie-sticky-vehicle-selector')) {
        dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
      }
    });
  });
})();

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const carBar = document.querySelector(".ie-sticky-vehicle-selector-find-your-car-bar");
    const stickyVehicleSelector = document.querySelector(".ie-sticky-vehicle-selector");
    const arrowDown = carBar.querySelector(".arrow-down");
    const arrowUp = carBar.querySelector(".arrow-up");
    const heroSection = document.querySelector(".ie-hero");
    const findCarTriggers = document.querySelectorAll(".find-car-trigger");

    // Initial state: show arrow down, hide arrow up
    arrowDown.style.display = "block";
    arrowUp.style.display = "none";

    carBar.addEventListener("click", () => {
      // Toggle the 'expanded' class
      carBar.classList.toggle("expanded");

      // Toggle the 'sticky-active' class on the parent element
      stickyVehicleSelector.classList.toggle("sticky-active");

      // Check if the bar has the 'expanded' class
      updateArrowState();
    });

    // Function to check if the device is mobile
    function isMobile() {
      return window.innerWidth <= 768;
    }

    // Show carBar and stickyVehicleSelector on mobile devices immediately on load
    if (isMobile()) {
      carBar.classList.add("shown");
      stickyVehicleSelector.classList.add("shown");
    }

    // Function to update visibility based on hero section scroll
    function updateVisibility() {
      if (!isMobile()) {
        const heroRect = heroSection.getBoundingClientRect();
        if (heroRect.bottom <= 0) {
          carBar.classList.add("shown");
          stickyVehicleSelector.classList.add("shown");
        } else {
          carBar.classList.remove("shown");
          stickyVehicleSelector.classList.remove("shown");

          // If the hero section is in view, reset to default state
          carBar.classList.remove("expanded");
          stickyVehicleSelector.classList.remove("sticky-active");
          updateArrowState();
        }
      }
    }

    // Function to update arrow states based on visibility
    function updateArrowState() {
      if (stickyVehicleSelector.classList.contains("sticky-active")) {
        arrowDown.style.display = "none";
        arrowUp.style.display = "block";
      } else {
        arrowDown.style.display = "block";
        arrowUp.style.display = "none";
      }
    }

    // Scroll event listener to update visibility
    window.addEventListener("scroll", updateVisibility);

    // Click event listener for find car triggers
    findCarTriggers.forEach(trigger => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        stickyVehicleSelector.classList.add("sticky-active");
        carBar.classList.add("expanded");
        updateArrowState();
      });
    });

  });
})();

(function() {
    // Select all elements with the class '.ie-buy-now-link'
    const buyNowLinks = document.querySelectorAll('.ie-buy-now-link');

    if (buyNowLinks.length > 0) {
        buyNowLinks.forEach(link => {
            // Add 'clicked' class on mouse down
            link.addEventListener('mousedown', function() {
                this.classList.add('clicked');
            });

            // Remove 'clicked' class on mouse up after a short delay
            link.addEventListener('mouseup', function() {
                setTimeout(() => this.classList.remove('clicked'), 300);
            });

            // Optionally, remove the class when mouse leaves the button (for better UX)
            link.addEventListener('mouseleave', function() {
                this.classList.remove('clicked');
            });
        });
    }
})();

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    function setupCarousel(containerSelector, carouselSelector, cardSelector, leftArrowSelector, rightArrowSelector) {
      const container = document.querySelector(containerSelector);
      const carousel = document.querySelector(carouselSelector);
      const leftArrow = document.querySelector(leftArrowSelector);
      const rightArrow = document.querySelector(rightArrowSelector);
      
      if (!container || !carousel || !leftArrow || !rightArrow) return;

      let scrollAmount = 0;

      function getCardWidth() {
        const card = document.querySelector(cardSelector);
        if (!card) return 0;
        const gap = parseFloat(getComputedStyle(carousel).gap) || 0;
        return card.offsetWidth + gap;
      }

      function updateMaxScroll() {
        return carousel.scrollWidth - container.clientWidth;
      }

      function updateArrows() {
        const maxScroll = updateMaxScroll();

        leftArrow.style.opacity = scrollAmount > 0 ? 1 : 0.5;
        leftArrow.style.cursor = scrollAmount > 0 ? "pointer" : "not-allowed";
      
        rightArrow.style.opacity = scrollAmount < maxScroll ? 1 : 0.5;
        rightArrow.style.cursor = scrollAmount < maxScroll ? "pointer" : "not-allowed";
      }

      function scrollCarousel(direction) {
        const cardWidth = getCardWidth();
        const maxScroll = updateMaxScroll();

        if (direction === "right") {
          scrollAmount = Math.min(scrollAmount + cardWidth, maxScroll);
        } else if (direction === "left") {
          scrollAmount = Math.max(scrollAmount - cardWidth, 0);
        }

        carousel.style.transform = `translateX(-${scrollAmount}px)`;
        updateArrows();
      }

      // Add event listeners
      leftArrow.addEventListener("click", () => scrollCarousel("left"));
      rightArrow.addEventListener("click", () => scrollCarousel("right"));

      // Ensure correct scroll position on window resize
      window.addEventListener("resize", () => {
        scrollAmount = Math.min(scrollAmount, updateMaxScroll());
        carousel.style.transform = `translateX(-${scrollAmount}px)`;
        updateArrows();
      });

      // Initial setup
      updateArrows();
    }

    // Initialize both carousels
    setupCarousel(".carousel-container", ".carousel", ".card", ".left-arrow", ".right-arrow");
    setupCarousel(".carousel-container-2", ".carousel-2", ".card-2", ".left-arrow-2", ".right-arrow-2");
  });
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
      const triggers = document.querySelectorAll(".popup-buy-now-trigger");
      
      if (!triggers.length) return;
      
      triggers.forEach(trigger => {
          const popup = trigger.querySelector(".ie-popup-buy-now");
          if (!popup) return;

          trigger.addEventListener("click", function (event) {
              if (!event.target.closest(".ie-popup-buy-now a")) { // Allow clicks on links
                  event.preventDefault(); // Prevents following the link only if clicking the button itself
                  event.stopPropagation(); // Prevent click from immediately closing popup
                  
                  const isActive = popup.style.display === "flex";
                  
                  // Close all popups and reset trigger styles before toggling the clicked one
                  document.querySelectorAll(".ie-popup-buy-now").forEach(p => p.style.display = "none");
                  document.querySelectorAll(".popup-buy-now-trigger").forEach(t => t.style.backgroundColor = "");
                  
                  if (!isActive) {
                      popup.style.display = "flex";
                      trigger.style.backgroundColor = "#4F4C4D";
                  }
              }
          });
      });
      
      document.addEventListener("click", function () {
          document.querySelectorAll(".ie-popup-buy-now").forEach(popup => popup.style.display = "none");
          document.querySelectorAll(".popup-buy-now-trigger").forEach(trigger => trigger.style.backgroundColor = "");
      });
  });
})();

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.location.pathname.includes('/all/')) {
      const easySearchEl = document.querySelector('[id$="__easysearch"]');
      const featuredCollectionsEl = easySearchEl?.nextElementSibling;

      if (
        easySearchEl &&
        featuredCollectionsEl &&
        featuredCollectionsEl.id.endsWith('__featured_collections_kT7faL')
      ) {
        featuredCollectionsEl.style.display = 'none';
      }
    }
  });
})();


(function () {
  const url = window.location.pathname;
  const match = url.match(/\/collections\/all\/([^\/]+)/i);

  if (match) {
    const subHandle = match[1].toLowerCase(); // e.g., "mk7-gti"
    const links = document.querySelectorAll('.collection-item');

    links.forEach((link, index) => {
      if (index === links.length - 1) return; // Skip the last item

      const href = link.getAttribute('href');
      if (href && !href.toLowerCase().includes(`/${subHandle}`)) {
        link.setAttribute('href', href.replace(/\/$/, '') + '/' + subHandle);
      }
    });
  }
})();


(function () {
  const discountElement = document.querySelector('div[data-discount]');
  const discountValue = discountElement ? parseFloat(discountElement.getAttribute('data-discount')) : 0;

  function applyDiscount() {
    const priceElement = document.querySelector('#product-price');
    const discountedPriceElement = document.querySelector('.discounted_product_price');

    if (!priceElement || !discountedPriceElement || isNaN(discountValue)) return;

    const priceText = priceElement.textContent.trim();
    const currencyMatch = priceText.match(/^[^\d]+/); // Match currency symbol
    const currency = currencyMatch ? currencyMatch[0] : '';
    const rawPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    if (isNaN(rawPrice)) return;

    const discountedPrice = rawPrice - (rawPrice * (discountValue / 100));
    discountedPriceElement.textContent = currency + discountedPrice.toFixed(2);
  }

  document.addEventListener("DOMContentLoaded", function () {
    // Run on page load
    applyDiscount();

    // Run on variant selection
    document.querySelectorAll('.variant-input').forEach(el => {
      el.addEventListener('click', () => {
        setTimeout(applyDiscount, 400);
      });
    });
  });
})();
